<div class="ui-dialog">
  <div class="ui-notify-icon ui-notify-warning" *ngIf="data.type == 'alert'"></div>
      
    <div class="ui-notify-icon ui-notify-info" *ngIf="data.type == 'info'"></div>
    
    <div class="ui-notify-icon ui-notify-error" *ngIf="data.type == 'error'">
      <span class="ui-notify-error-cross">
        <span class="ui-notify-line ui-notify-left"></span>
        <span class="ui-notify-line ui-notify-right"></span>
      </span>
    </div>
      
    <div class="ui-notify-icon ui-notify-success animate" *ngIf="data.type == 'success'">
      <span class="ui-notify-line ui-notify-tip animateSuccessTip"></span>
      <span class="ui-notify-line ui-notify-long animateSuccessLong"></span>
    
      <div class="ui-notify-placeholder"></div>
      <div class="ui-notify-fix"></div>
    </div>
  
  <h3 class="ui-dialog-title ui-title" mat-dialog-title [ngClass]="{'center': data.type != ''}" *ngIf="data.title != ''">{{data.title}}</h3>

  <div class="ui-dialog-content" mat-dialog-content>
    <div [innerHTML]="data.message" [ngClass]="{'center': data.type != ''}"></div>
  </div>

  <div class="ui-dialog-actions" mat-dialog-actions>
    <button mat-button (click)="onCancel()" *ngIf="data.buttonCancelText !== ''">{{data.buttonCancelText}}</button>
    <button mat-button color="primary" cdkFocusInitial [mat-dialog-close]="true" (click)="onConfirm()" *ngIf="data.buttonConfirmText !== ''">{{data.buttonConfirmText}}</button>
  </div>
</div>